module.exports = __webpack_public_path__ + "static/img/RAPD-1U235-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD-1U235-G_1.png
// module id = Vt2N
// module chunks = 0